// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__cvVAu","logo":"NavBar_logo__zZ2ZZ","nav-links":"NavBar_nav-links__0r1d0"};